import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ParameterDictionary, ReportSource } from "../../../../../api/types/workbookRuns.types";

export interface TextFiltersDictionaryItemsContextType {
  getDictionaryItems: (
    filterIdentifier: string,
    clientCode: string,
    reportSource: ReportSource
  ) => Promise<ParameterDictionary[] | undefined>;
}

export const TextFiltersDictionaryItemsContext = createContext<TextFiltersDictionaryItemsContextType | undefined>(
  undefined
);

export const useTextFiltersDictionaryItemsContext = () => {
  return defined(
    use(TextFiltersDictionaryItemsContext),
    "Attempt to use TextFiltersDictionaryItemsContext without provider"
  );
};
